import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";


interface VoteBarProps {
    option?: string;
    votes: number ;
    totalCount: number ;
    variant?: string | undefined;
    label?: string | undefined;
}


const VoteBar = (props: VoteBarProps) => {
    const percentage = props.totalCount > 0 ? (props.votes / props.totalCount) * 100 : 0;
    return (
        <>
            <div className="mb-3">
                <div className="d-flex justify-content-between mb-1">
                    <span>{props.option}</span>
                    <span>{props.votes} ({percentage.toFixed(0)}%)</span>
                </div>

                <ProgressBar
                    now={percentage}
                    variant={props.variant}
                    label={props.label}
                    style={{ height: "10px" }}
                />
            </div>

        </>
    );
};

export default VoteBar;
